// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__AJhNb","Header":"Layout_Header__oiU3B","LocaleBtn":"Layout_LocaleBtn__Xcuk0","LogoutBtn":"Layout_LogoutBtn__l0U5p"};